import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { ErrorPage, LoadingPage } from "@digital-services/shell";

import { loginRequest } from "../../authConfig";

interface Props {
  children: ReactNode;
}

function ErrorComponent() {
  const { t } = useTranslation(undefined, { keyPrefix: "account" });
  return <ErrorPage title="Sign In Error" message={t("sigin.error.message")} />;
}

function Authenticating() {
  const { t } = useTranslation(undefined, { keyPrefix: "account" });
  return <LoadingPage message={t("authenticate.message")} />;
}

const RequireAuth: FunctionComponent<Props> = ({ children }) => {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      loadingComponent={Authenticating}
      errorComponent={ErrorComponent}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};

export default RequireAuth;
